export const getJuraData = () => ({
  name: "Jura",
  country: "France",
  description: "Le Jura est une petite région viticole de l'est de la France, connue pour ses vins uniques et traditionnels, notamment le vin jaune et le vin de paille. Cette région montagneuse produit des vins avec des caractères distinctifs grâce à son terroir particulier et ses méthodes de vinification ancestrales.",
  type: "region",
  area: "2,100 hectares",
  production: "80,000 hectolitres",
  climate: "Semi-continental avec influences montagneuses",
  soil: "Marnes grises et bleues, calcaires, argiles",
  subregions: {
    "arbois": {
      name: "Arbois",
      description: "Première AOC de France (1936), Arbois est le cœur viticole du Jura avec ses vins rouges, blancs et rosés.",
      characteristics: {
        "Terroir": "Marnes grises et calcaires, exposition sud-est",
        "Climat": "Semi-continental avec étés chauds et hivers froids",
        "Altitude": "250-400 mètres"
      },
      grapeVarieties: {
        "Rouges": ["Poulsard", "Trousseau", "Pinot Noir"],
        "Blancs": ["Chardonnay", "Savagnin"]
      },
      wineStyles: {
        "Rouge": "Vins légers et fruités, parfaits pour la gastronomie locale",
        "Blanc": "Vins secs et minéraux, avec une belle acidité",
        "Rosé": "Rosés délicats et aromatiques"
      },
      foodPairing: "Comté, morilles, volaille de Bresse, saucisse de Morteau"
    },
    "chateau-chalon": {
      name: "Château-Chalon",
      description: "Appellation prestigieuse dédiée exclusivement au vin jaune, produit selon des méthodes ancestrales.",
      characteristics: {
        "Terroir": "Marnes bleues, exposition sud",
        "Élevage": "6 ans minimum sous voile de levures",
        "Production": "Très limitée, environ 50,000 bouteilles par an"
      },
      grapeVarieties: {
        "Blancs": ["Savagnin"]
      },
      wineStyles: {
        "Vin Jaune": "Vin oxydatif complexe, notes de noix, curry, épices"
      },
      foodPairing: "Comté vieux, foie gras, volaille au vin jaune"
    },
    "l-etoile": {
      name: "L'Étoile",
      description: "Petite appellation produisant des vins blancs et du vin de paille, réputée pour ses vins de garde.",
      characteristics: {
        "Terroir": "Marnes grises avec fossiles d'étoiles de mer",
        "Climat": "Microclimat favorable à la pourriture noble",
        "Surface": "60 hectares"
      },
      grapeVarieties: {
        "Blancs": ["Chardonnay", "Savagnin", "Poulsard (blanc)"]
      },
      wineStyles: {
        "Blanc": "Vins secs et minéraux, grande longévité",
        "Vin de Paille": "Vin liquoreux rare et précieux"
      },
      foodPairing: "Poissons nobles, crustacés, desserts aux fruits secs"
    },
    "cotes-du-jura": {
      name: "Côtes du Jura",
      description: "Appellation générale couvrant toute la région, permettant une grande diversité de styles de vins.",
      characteristics: {
        "Terroir": "Diversité géologique importante",
        "Flexibilité": "Autorise tous les cépages et styles du Jura",
        "Innovation": "Laboratoire d'expérimentation viticole"
      },
      grapeVarieties: {
        "Rouges": ["Poulsard", "Trousseau", "Pinot Noir"],
        "Blancs": ["Chardonnay", "Savagnin"],
        "Autres": ["Gamay", "Pinot Gris"]
      },
      wineStyles: {
        "Rouge": "Vins fruités et accessibles",
        "Blanc": "Vins secs et aromatiques",
        "Mousseux": "Crémant du Jura",
        "Vin de Paille": "Vins liquoreux traditionnels"
      },
      foodPairing: "Cuisine traditionnelle jurassienne, fromages locaux"
    }
  },
  statistics: {
    "Surface totale": "2,100 hectares",
    "Production annuelle": "80,000 hectolitres",
    "Nombre de domaines": "200+",
    "Appellations": "4 AOC",
    "Export": "15%"
  },
  characteristics: {
    "Climat": "Semi-continental avec influences montagneuses, étés chauds et hivers rigoureux",
    "Sol": "Marnes grises et bleues du Jurassique, calcaires, argiles",
    "Altitude": "250-500 mètres",
    "Exposition": "Sud et sud-est dominants"
  },
  wineStyles: {
    "Vin Jaune": "Vin blanc oxydatif unique au monde, élevé 6 ans minimum sous voile de levures",
    "Vin de Paille": "Vin liquoreux produit à partir de raisins séchés sur paille",
    "Crémant": "Vins effervescents de méthode traditionnelle",
    "Vins Rouges": "Vins légers et fruités, parfaits pour la gastronomie",
    "Vins Blancs": "Vins secs et minéraux, avec une belle acidité"
  },
  history: "La viticulture dans le Jura remonte à l'époque romaine. Au Moyen Âge, les moines ont développé les techniques de vinification, notamment pour le vin jaune. La région a été la première à obtenir une AOC en 1936 (Arbois). Les méthodes traditionnelles, comme l'élevage sous voile pour le vin jaune, sont encore pratiquées aujourd'hui, faisant du Jura une région viticole unique et authentique.",
  foodPairing: "Cuisine traditionnelle jurassienne : Comté, Morbier, vin jaune, volaille de Bresse, saucisse de Morteau, morilles, truites du Doubs. Les vins du Jura s'accordent parfaitement avec la gastronomie locale et les fromages affinés."
}); 